import { editProductPrice } from '../../_services/product_price.service';
import { getCompany } from '../../_utils/storage_handler';
import { 
    buildPriceBody,
    validateProductPriceBody 
} from './product_price.input';

export const editProductPriceEvent = async (id) => {
    let body = buildPriceBody(getCompany());
    validateProductPriceBody(body);
    let res = await editProductPrice(body, id);
    if(! res.ok){
        throw new Error(res.error);
    }
    
    return res;
}